import { createReducer, on } from '@ngrx/store';
import * as DownloadDocumentActions from './download-document.actions';
import { DownloadDocumentEntity } from './download-document.models';

export const DOWNLOAD_DOCUMENT_FEATURE_KEY = 'downloadDocument';

export interface DownloadDocumentState {
  documents: DownloadDocumentEntity[];
  loaded: boolean;
  error?: string | null;
}

export const initialState: DownloadDocumentState = {
  documents: [],
  loaded: false,
  error: null,
};

const reducer = createReducer(
  initialState,
  on(DownloadDocumentActions.initDownloadData, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(DownloadDocumentActions.clearDownloadDocuments, () => initialState),
  on(DownloadDocumentActions.loadDownloadDataSuccess, (state, { documents }) => ({
    ...state,
    documents,
    loaded: true,
    error: null,
  })),
  on(DownloadDocumentActions.loadDownloadDataFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error,
  }))
);

export function downloadDocumentReducer(state: DownloadDocumentState | undefined, action: any) {
  return reducer(state, action);
}
